import {
  INIT, SUCCESS, LOADING, ERROR,
} from '../../../utils/constants';
import {
  GET_AZURE_FUNCTIONAL_APP, GET_AZURE_FUNCTIONAL_APP_SUCCESS, GET_AZURE_FUNCTIONAL_APP_ERROR
} from './constant';


const initialState = {
  phase: INIT,
  azureFunctionalAppList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */
 

export function AzureFunctionalAppStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_FUNCTIONAL_APP:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_FUNCTIONAL_APP_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureSubList: action.data,
        error: null,
      };
    case GET_AZURE_FUNCTIONAL_APP_ERROR:
      return { ...state, phase: ERROR, error: action.error };





    default:
      return state;
  }
}
